import { render, staticRenderFns } from "./popular-products-icon.vue?vue&type=template&id=2dc5177c&functional=true&"
import script from "./popular-products-icon.vue?vue&type=script&lang=js&"
export * from "./popular-products-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports